import { PermissionType } from "../api/types"
import { DashboardTabNameType } from "../pages/Dashboard/DashboardPage"

type ID = string | number

/////////////////////////////////////////////////////////////////////
//                         !! WARNING !!                           //
//     When creating a new path, make sure the index is unique     //
//     SideBar.tsx uses the index to determine the active tab      //
//                                                                 //
//     When adding a new path to 'getPaths', consider adding       //
//        its index to 'sideBarItemsPaths', if necessary           //
//                         !! WARNING !!                           //
/////////////////////////////////////////////////////////////////////

/* eslint-disable i18next/no-literal-string */
export const getPaths = {
  home: '/',
  managers: {
    _base: 'managers',
    signIn: '/managers/sign_in'
  },
  brands: {
    _base: 'brands',
    no_permissions: {
      _base: 'no_permissions',
      index: '/brands/no_permissions'
    },
    missions: {
      _base: 'missions',
      index: '/brands/missions',
      ongoing: '/brands/missions/ongoing',
      before_start: '/brands/missions/before_start',
      completed: '/brands/missions/completed',
      in_the_making: '/brands/missions/in_the_making'
    },
    mission: {
      _base: 'mission',
      index: '/brands/mission',
      details: (id: ID) => `/brands/mission/${id}/details`,
      stores_summary: (id: ID) => `/brands/mission/${id}/stores_summary`,
      stats: (id: ID) => `/brands/mission/${id}/stats`,
      answers: (id: ID) => `/brands/mission/${id}/answers`,
      ninjas_assign: (id: ID) => `/brands/mission/${id}/ninjas_assign`
    },
    wizard: {
      _base: 'wizard',
      index: '/brands/wizard',
      step_1: (id: ID) => `/brands/wizard/${id}/step_1`,
      step_2: (id: ID) => `/brands/wizard/${id}/step_2`,
      step_3: (id: ID) => `/brands/wizard/${id}/step_3`,
      step_4: (id: ID) => `/brands/wizard/${id}/step_4`
    },
    dashboard: {
      _base: 'dashboard',
      index: '/brands/dashboard',
      tab: (tab: DashboardTabNameType) => `/brands/dashboard/${tab}`
    },
    chatbot: {
      _base: 'chatbot',
      index: '/brands/chatbot',
      chat: (id: ID) => `/brands/chatbot/${id}`
    }
  }
} as const


export const sideBarItemsPaths = {
  missions: [
    getPaths.brands.missions.index,
    getPaths.brands.mission.index,
    getPaths.brands.wizard.index
  ],
  dashboard: [
    getPaths.brands.dashboard.index
  ],
  chatbot: [
    getPaths.brands.chatbot.index
  ]
} as const

export type sideBarItemsIds = keyof typeof sideBarItemsPaths


type RedirectPermissionsType = Record<PermissionType, {
  path: string,
  redirects: PermissionType[]
}>

export const redirectPermissions: RedirectPermissionsType = {
  'missions_viewer': {
    path: getPaths.brands.missions.ongoing,
    redirects: [
      'dashboard_viewer'
    ],
  },
  'mission_creator': {
    path: getPaths.brands.missions.ongoing,
    redirects: [
      'missions_viewer',
      'dashboard_viewer'
    ],
  },
  'answers_validator': {
    path: getPaths.brands.missions.ongoing,
    redirects: [
      'missions_viewer',
      'dashboard_viewer'
    ]
  },
  'dashboard_viewer': {
    path: getPaths.brands.dashboard.tab('sales_dashboard'),
    redirects: [
      'missions_viewer'
    ]
  },
  'management_dashboard_viewer': {
    path: getPaths.brands.dashboard.tab('management_dashboard'),
    redirects: [
      'dashboard_viewer',
      'missions_viewer'
    ]
  },
  'chatbot_user': {
    path: getPaths.brands.chatbot.index,
    redirects: [
      'dashboard_viewer',
      'missions_viewer'
    ]
  }
}
